// app/src/widgets/Sidebar/Sidebar.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import API_CONFIG from '@shared/api/api.config';
import { useAuth, useTooltip } from '@app/providers';
import TopDonators from './TopDonators';
import UserCard from '@entities/user/ui/UserCard';
import { getFrameType } from '@entities/user/ui/UserAvatar';
import './Sidebar.css';

const Sidebar = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const { showTooltip, hideTooltip } = useTooltip();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        // Используем обычный axios для публичного доступа к ТОПу
        const res = await axios.get(`${API_CONFIG.API_URL}/users/`);
        const usersData = Array.isArray(res.data) ? res.data : (res.data.results || []);
        setUsers(usersData.filter(user => user.is_public !== false));
        setError(null);
      } catch (err) {
        console.error("Sidebar fetch users error:", err);
        setError('Не удалось загрузить пользователей');
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  const topUsers = users
    .sort((a, b) => (b.rating || 0) - (a.rating || 0))
    .slice(0, 20);

  return (
    <aside className="sidebar" style={{ 
      height: '100%', 
      overflow: 'hidden', 
      display: 'flex', 
      flexDirection: 'column',
      padding: 'var(--spacing-xl) 0'
    }}>
      
      {/* Top Donators Block */}
      <div style={{ display: 'flex', flexDirection: 'column', marginBottom: 'var(--spacing-lg)', maxHeight: '40%' }}>
        <TopDonators />
      </div>

      {/* Top Users Block */}
      <div className="sidebar-content" style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <div className="sidebar-section-header">
          <h3 className="text-center">🏆 ТОП ПОЛЬЗОВАТЕЛЕЙ</h3>
        </div>
        
        <div style={{ flex: 1, overflowY: 'auto', paddingRight: '4px' }}>
          {loading ? (
            <div className="flex-center" style={{ padding: '20px' }}><div className="loading-dots"><span>.</span><span>.</span><span>.</span></div></div>
          ) : error ? (
            <div className="text-danger text-xs text-center">{error}</div>
          ) : (
            <div className="top-users-list">
              {topUsers.map((user, index) => (
                <div key={user.id} className="top-user-item">
                  <div className="top-user-rank">#{index + 1}</div>
                  <UserCard
                    user={user}
                    showRole={true}
                    showStats={false}
                    size="small"
                    onClick={() => navigate(`/profile/${user.username}`)}
                    avatarFrame={getFrameType(user)}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
